import { API_BASE_URL } from "../../../helpers/apiBaseUrl";

const token = () => {
  const value = localStorage.getItem("token") || sessionStorage.getItem("token");
  if (!value) return "";
  try { return JSON.parse(value); } catch { return value; }
};

const request = async (path, options = {}) => {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${token()}`, ...options.headers },
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || payload.success === false) throw new Error(payload.message || payload.error || "Request failed.");
  return payload;
};

const toView = (item) => ({ ...item, status: item.status ? "Active" : "Inactive" });

export const getDesignations = async () => {
  const response = await request("/designations?per_page=500");
  return (response.data?.data || []).map(toView);
};

export const createDesignation = (item) => request("/designations", {
  method: "POST",
  body: JSON.stringify({ name: item.name, description: item.description, status: item.status === "Active" }),
});

export const updateDesignation = (id, item) => request(`/designations/${id}`, {
  method: "PUT",
  body: JSON.stringify({ name: item.name, description: item.description, status: item.status === "Active" }),
});

export const deleteDesignation = (id) => request(`/designations/${id}`, { method: "DELETE" });
